<template>
  <div class="px-3 text-sm">
    <div class="w-full md:flex items-center">
      <label class="md:w-1/5 tracking-wide textColorDarkBlack text-sm font-bold" for="coupon">
        折扣碼
      </label>
      <div class="md:w-4/5 flex items-center" v-if="isSuccess === null || isSuccess === false">
        <input v-model.trim="inputVal" class="border borderColorgray rounded appearance-none bg-transparent w-full text-gray-700 mr-3 py-2 px-2 leading-tight focus:outline-none"
          type="text" placeholder="" name="coupon" autocomplete="off">
        <button class="flex-shrink-0 button-black text-sm py-1 px-4 rounded cursor-pointer focus:outline-none" type="button" @click="emitCoupon">
          使用
        </button>
      </div>
      <div class="lg:w-4/5 flex items-center" v-if="isSuccess === true">
        <p> {{ couponCode }}</p>
        <button class="flex-shrink-0 button-black text-sm py-1 px-4 rounded cursor-pointer ml-2 focus:outline-none" type="button" @click="deleteCoupon">
          取消
        </button>
      </div>
    </div>

    <div class="w-full lg:flex items-center justify-end" v-if="isSuccess === false">
      <div class="lg:w-4/5 flex items-center">
        <p class="text-xs text-pinky">未符合活動規則，折扣碼無法使用</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Coupon',
  data () {
    return {
      inputVal: null,
      useCoupon: null,

      isSuccess: null
    }
  },
  props: {
    couponCode: {
      type: String,
      default: ''
    }
  },
  mounted () {
    this.initCode()
  },
  methods: {
    initCode () {
      let self = this
      if (self.couponCode) {
        self.isSuccess = true
      }
    },
    emitCoupon () {
      let self = this
      if (self.inputVal) {
        axios.post(`/cart/coupon/check?coupon=${self.inputVal}`)
          .then(() => {
            self.$emit('setCoupon', self.inputVal)
            self.isSuccess = true
            self.inputVal = null
          })
          .catch(() => {
            self.isSuccess = false
            self.inputVal = null
          })
      }
    },
    deleteCoupon () {
      let self = this
      self.$emit('setCoupon', '')
      self.isSuccess = null
    }
  }
}
</script>
